import React from 'react'

import { Box, Display, Text, FontWeight } from '@gousto-internal/citrus-react'
import TextInput from 'Form/Input'
import classNames from 'classnames'
import { Heading } from 'goustouicomponents'
import PropTypes from 'prop-types'

import { RibbonTriggerContainer } from 'components/RibbonTrigger'
import { useIsExplainTheWizardEnabled } from 'routes/Signup/Steps/ExplainTheWizard'
import { signupConfig } from 'routes/Signup/signupConfig'

import { Button } from '../../Button'
import { Image } from '../../Image'
import { PostcodeStepMessage } from './PostcodeStepMessage'

import css from '../../Signup.css'
import postcodeCss from './PostcodeStep.css'

function PostcodeStep(props) {
  const isExplainTheWizardEnabled = useIsExplainTheWizardEnabled()
  const {
    tempPostcode,
    changeTempPostcode,
    postcodePending,
    deliveryDaysError,
    isGoustoOnDemandEnabled,
    isWizardWithoutImagesEnabled,
  } = props
  const handleClick = () => {
    const { nextStepName, changePostcode, signupGetCountByPostcode } = props

    signupGetCountByPostcode(tempPostcode)
    changePostcode(tempPostcode, nextStepName)
  }

  return (
    <div className={css.stepContainer} data-testing="signupPostcodeStep">
      <div className={css.fullWidth}>
        <div
          className={classNames(css.header, {
            [css.wizardWithoutImagesHeader]: isWizardWithoutImagesEnabled,
          })}
        >
          {isExplainTheWizardEnabled ? (
            <>
              <Box paddingBottom={2}>
                <Text size={5} fontWeight={FontWeight.Bold}>
                  {signupConfig.postCodeStep.explainTheWizardTitle}
                </Text>
              </Box>
              <Text size={2}>{signupConfig.postCodeStep.explainTheWizardDescription}</Text>
              {!isWizardWithoutImagesEnabled && (
                <Box display={[Display.None, Display.Block]}>
                  <Image name="where-to-deliver" />
                </Box>
              )}
            </>
          ) : (
            <>
              <Heading type="h1">
                {isGoustoOnDemandEnabled
                  ? signupConfig.postCodeStep.goustoOnDemandTitle
                  : signupConfig.postCodeStep.title}
              </Heading>
              {!isWizardWithoutImagesEnabled && <Image name="where-to-deliver" />}
            </>
          )}
        </div>
        <div
          className={classNames(css.body, {
            [postcodeCss.wizardWithoutImagesBody]: isWizardWithoutImagesEnabled,
          })}
        >
          <div className={postcodeCss.inputContainer}>
            <form
              onSubmit={(e) => {
                if (e) {
                  e.preventDefault()
                }
                handleClick()
              }}
              action="#"
              className={postcodeCss.row}
            >
              <div
                className={classNames(postcodeCss.container, {
                  [postcodeCss.wizardWithoutImagesContainer]: isWizardWithoutImagesEnabled,
                })}
              >
                <div
                  className={classNames(postcodeCss.postcodeContainer, {
                    [postcodeCss.wizardWithoutImagesCodeContainer]: isWizardWithoutImagesEnabled,
                  })}
                >
                  <div className={postcodeCss.postcodeLabel}>Postcode</div>
                  <TextInput
                    isFixed
                    placeholder="e.g. W3 7UP"
                    onChange={changeTempPostcode}
                    minLength={5}
                    maxLength={8}
                    value={tempPostcode}
                    mask
                    dataTesting="signupPostcodeInput"
                    isInCheckout
                    error={deliveryDaysError}
                    autoComplete="postal-code"
                  />
                </div>
                <Button
                  disabled={tempPostcode.length < 5}
                  data-testing="signupPostcodeCTA"
                  onClick={handleClick}
                  pending={postcodePending}
                  width="full"
                >
                  Continue
                </Button>
              </div>
            </form>
          </div>
          <PostcodeStepMessage
            deliveryDaysError={deliveryDaysError}
            isGoustoOnDemandEnabled={isGoustoOnDemandEnabled}
            isWizardWithoutImagesEnabled={isWizardWithoutImagesEnabled}
          />
        </div>
      </div>
      <RibbonTriggerContainer name="wizard-postcode-step" />
    </div>
  )
}

PostcodeStep.propTypes = {
  deliveryDaysError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object]),
  postcodePending: PropTypes.bool,
  tempPostcode: PropTypes.string,
  changeTempPostcode: PropTypes.func,
  changePostcode: PropTypes.func.isRequired,
  nextStepName: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isGoustoOnDemandEnabled: PropTypes.bool,
  signupGetCountByPostcode: PropTypes.func.isRequired,
  isWizardWithoutImagesEnabled: PropTypes.bool,
}

PostcodeStep.defaultProps = {
  deliveryDaysError: '',
  postcodePending: false,
  tempPostcode: '',
  changeTempPostcode: () => {},
  nextStepName: '',
  isGoustoOnDemandEnabled: false,
  isWizardWithoutImagesEnabled: false,
}

export { PostcodeStep }
